<div
  #chatBox
  #dragRef="cdkDrag"
  coinResizable
  class="chat-dialog"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  animate.enter="fade-in"
  animate.leave="fade-out"
  [drag]="dragRef"
  [cdkDragConstrainPosition]="constrainPosition"
  [tabIndex]="-1">
  <coin-celebration-animation [hasMessages]="hasMessages()" [isFaqScreenActive]="isFaqScreenActive()" />

  <coin-chat-dialog-header
    cdkDragHandle
    [title]="'chat-bot.window.title' | translate"
    [isFaqActive]="isFaqScreenActive()"
    [theme]="celebrationType()"
    (closePress)="closeChat()"
    (faqPress)="toggleFaq()"></coin-chat-dialog-header>

  @if (isFaqScreenActive()) {
    <coin-chat-faq-screen (backPress)="toggleFaq()" />
  } @else {
    <coin-chat-dialog-content>
      @for (message of messages(); track $index) {
        <coin-chat-message
          [message]="message"
          [gid]="user()?.gid"
          (download)="downloadFile($event)"></coin-chat-message>
      } @empty {
        <coin-chat-start-view
          [name]="user()?.firstName"
          [prompts]="prompts()"
          [newPromptLabel]="'chat-bot.actions.another-suggestion' | translate"
          (promptSelected)="sendMessage($event)" />
      }
    </coin-chat-dialog-content>
  }

  @if (!isFaqScreenActive()) {
    <coin-chat-dialog-footer
      [disableSendButton]="isSendButtonDisabled()"
      [disableCleanButton]="messages().length === 0 || hasPendingMessages()"
      (cleanMessage)="cleanMessages()"
      (sendMessage)="sendMessage($event)"></coin-chat-dialog-footer>
  }

  <!-- Resize handles -->
  <div
    class="resize-handle bottom-right"
    data-direction="bottom-right">
    <mat-icon>filter_list</mat-icon>
  </div>

</div>
